import { randInt } from './helpers';

export function RandomGameName() {
  const consonants = [
    'B','C','D','F','G','H','J',
    'K','L','M','N','P','Q',
    'R','S','T','V','W','X','Y','Z'
  ];

  const vowels = ['A', 'E', 'I', 'O', 'U'];

  return `${
    vowels[randInt(0, vowels.length - 1)]
  }${
    consonants[randInt(0, consonants.length - 1)]
  }${
    vowels[randInt(0, vowels.length - 1)]
  }${
    consonants[randInt(0, consonants.length - 1)]
  }${
    vowels[randInt(0, vowels.length - 1)]
  }${
    consonants[randInt(0, consonants.length - 1)]
  }`;
}